const fmt = (v) =>
  "₹" + Number(v).toLocaleString("en-IN", { maximumFractionDigits: 0 });
const truncate = (str, n = 12) =>
  str ? (str.length > n ? str.slice(0, n) + "…" : str) : "N/A";

const KPI_CONFIG = [
  {
    key: "total_revenue",
    label: "Basic Revenue",
    color: "var(--green)",
    format: fmt,
    subtitle: "Excluding tax",
  },
  {
    key: "total_bills",
    label: "Total Bills",
    color: "var(--blue)",
    format: (n) => Number(n).toLocaleString("en-IN"),
  },
  {
    key: "unique_customers",
    label: "Unique Customers",
    color: "var(--purple)",
    format: (n) => Number(n).toLocaleString("en-IN"),
  },
  {
    key: "total_qty",
    label: "Total Qty Sold",
    color: "var(--amber)",
    format: (n) => Number(n).toLocaleString("en-IN"),
  },
  { key: "total_cgst", label: "Total CGST", color: "var(--teal)", format: fmt },
  { key: "total_sgst", label: "Total SGST", color: "var(--violet)", format: fmt },
  { key: "total_igst", label: "Total IGST", color: "var(--orange)", format: fmt },
  { key: "total_tax", label: "Total Tax", color: "var(--red)", format: fmt },
  {
    key: "total_revenue_incl",
    label: "Total Revenue",
    color: "var(--emerald)",
    format: fmt,
    subtitle: "Including tax",
  },
  {
    key: "total_discount",
    label: "Total Discount",
    color: "var(--orange2)",
    format: fmt,
  },
  {
    key: "avg_bill_value",
    label: "Avg Bill Value",
    color: "var(--green-dark)",
    format: fmt,
  },
];

export default function KPICards({ kpi, topState, bottomState }) {
  return (
    <div className="summary-row">
      {KPI_CONFIG.map((c) => (
        <div
          key={c.key}
          className="summary-card"
          style={{ borderTopColor: c.color }}
        >
          <div className="summary-label">{c.label}</div>
          <div className="summary-value">
            {kpi ? c.format(kpi[c.key] ?? 0) : <span className="skeleton" />}
            <div
              style={{
                fontSize: "11px",
                color: "var(--muted)",
                marginTop: "4px",
              }}
            >
              {c.subtitle && (
                <span
                  style={{
                    marginLeft: "4px",
                    fontSize: "10px",
                    color: "var(--light)",
                    fontWeight: 400,
                  }}
                >
                  ({c.subtitle})
                </span>
              )}
            </div>
          </div>
        </div>
      ))}

      {/* 🏆 Best Selling State */}
      <div className="summary-card" style={{ borderTopColor: "var(--pink)" }}>
        <div className="summary-label">
          <span style={{ marginRight: "4px" }}>🏆</span>Best Selling State
        </div>
        {topState ? (
          <>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "22px",
                  height: "22px",
                  borderRadius: "50%",
                  background: "var(--green-light)",
                  flexShrink: 0,
                }}
              >
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path
                    d="M6 10V2M6 2L2 6M6 2L10 6"
                    stroke="var(--green-dark)"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <div
                className="summary-value"
                style={{ fontSize: "15px", color: "var(--pink)" }}
              >
                {truncate(topState.state)}
              </div>
            </div>
            <div
              style={{
                fontSize: "11px",
                color: "var(--muted)",
                marginTop: "4px",
              }}
            >
              {fmt(topState.revenue)} · {topState.total_bills} bills
            </div>
          </>
        ) : (
          <span className="skeleton" />
        )}
      </div>

      {/* 📉 Lowest Selling State */}
      <div className="summary-card" style={{ borderTopColor: "var(--crimson)" }}>
        <div className="summary-label">
          <span style={{ marginRight: "4px" }}>📉</span>Lowest Selling State
        </div>
        {bottomState ? (
          <>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "22px",
                  height: "22px",
                  borderRadius: "50%",
                  background: "var(--red-light)",
                  flexShrink: 0,
                }}
              >
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path
                    d="M6 2V10M6 10L2 6M6 10L10 6"
                    stroke="var(--crimson)"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <div
                className="summary-value"
                style={{ fontSize: "15px", color: "var(--crimson)" }}
              >
                {truncate(bottomState.state)}
              </div>
            </div>
            <div
              style={{
                fontSize: "11px",
                color: "var(--muted)",
                marginTop: "4px",
              }}
            >
              {fmt(bottomState.revenue)} · {bottomState.total_bills} bills
            </div>
          </>
        ) : (
          <span className="skeleton" />
        )}
      </div>
    </div>
  );
}
